import { JSX } from 'react';

import '@src/components/accent-circle/index.scss';

export const AccentCircle = ({
  centerMobile,
}: {
  centerMobile?: boolean;
}): JSX.Element => {
  return (
    <svg
      className={
        centerMobile
          ? 'pi-accent__circle pi-accent__circle-center-x'
          : 'pi-accent__circle'
      }
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      focusable="false"
      aria-hidden="true"
      fill="currentColor"
    >
      <circle
        width="100%"
        height="100%"
        cx="12"
        cy="12"
        r="12"
        preserveAspectRatio="none"
      />
    </svg>
  );
};
